import React from 'react';

const Page3 = ({
    billItems,
    setBillItems,
    itemSelectionMode,
    setItemSelectionMode,
    itemSearchTerm,
    setItemSearchTerm,
    filteredProducts,
    handleOpenItemModal,
    selectedOrderId,
    setSelectedOrderId,
    orders,
    selectedDocId,
    setSelectedDocId,
    documents,
    handleAddItemsFromSource,
    handleEditItem,
    handleRemoveBillItem,
    netTotal,
    setPage,
    isPage3NextDisabled
}) => {
  return (
    <>
   <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 border-b pb-4">Item Details (Step 3/5)</h1>
        <div className="space-y-4">
            <div className="p-4 bg-gray-50 rounded-lg space-y-4">
                <div>
                    <label htmlFor="itemSelectionMode" className="block text-sm font-medium text-gray-700 mb-1">Item Selection Mode</label>
                    <select id="itemSelectionMode" value={itemSelectionMode} onChange={(e) => setItemSelectionMode(e.target.value)} className="w-full md:w-1/3 p-2 border border-gray-300 rounded-md shadow-sm">
                        <option value="list">From Item List</option>
                        <option value="order">From Order</option>
                        <option value="document">From DC/GRN</option>
                    </select>
                </div>
                {itemSelectionMode === 'list' && (
                    <div className="relative">
                        <label htmlFor="itemSearch" className="block text-sm font-medium text-gray-700 mb-1">Search & Add Item</label>
                        <input type="text" id="itemSearch" value={itemSearchTerm} onChange={(e) => setItemSearchTerm(e.target.value)} placeholder="Search by Item No, Description, Make..." className="w-full p-2 border border-gray-300 rounded-md"/>
                        {filteredProducts.length > 0 && (
                            <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-48 overflow-y-auto shadow-lg">
                                {filteredProducts.map(p => 
                                    <li key={p.id} onClick={() => handleOpenItemModal(p)} className="p-2 hover:bg-indigo-100 cursor-pointer">
                                        <div className="font-semibold">{p.itemNo} - {p.desc}</div>
                                        <div className="text-sm text-gray-500">{p.make}</div>
                                    </li>
                                )}
                            </ul>
                        )}
                    </div>
                )}
                {itemSelectionMode === 'order' && (
                    <div className="flex items-end space-x-2">
                        <div className="flex-grow">
                            <label htmlFor="orderSelect" className="block text-sm font-medium text-gray-700 mb-1">Select Order</label>
                            <select id="orderSelect" value={selectedOrderId} onChange={e => setSelectedOrderId(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md">
                                <option value="">-- Select an Order --</option>
                                {orders.map(o => <option key={o.id} value={o.id}>{o.id} - {o.customer}</option>)}
                            </select>
                        </div>
                        <button onClick={() => handleAddItemsFromSource(orders.find(o => o.id === selectedOrderId)?.items || [])} disabled={!selectedOrderId} className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md disabled:bg-gray-400">Add Items</button>
                    </div>
                )}
                {itemSelectionMode === 'document' && (
                     <div className="flex items-end space-x-2">
                        <div className="flex-grow">
                            <label htmlFor="docSelect" className="block text-sm font-medium text-gray-700 mb-1">Select Document</label>
                            <select id="docSelect" value={selectedDocId} onChange={e => setSelectedDocId(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md">
                                <option value="">-- Select a Document --</option>
                                {documents.map(d => <option key={d.id} value={d.id}>{d.id} ({d.type}) - {d.party}</option>)}
                            </select>
                        </div>
                        <button onClick={() => handleAddItemsFromSource(documents.find(d => d.id === selectedDocId)?.items || [])} disabled={!selectedDocId} className="px-4 py-2 bg-indigo-600 text-white font-semibold rounded-md disabled:bg-gray-400">Add Items</button>
                    </div>
                )}
            </div>
            
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border">
                    <thead className="bg-gray-200 text-sm">
                        <tr>
                            <th className="text-left py-2 px-3">S.No</th>
                            <th className="text-left py-2 px-3">Item Desc.</th>
                            <th className="text-left py-2 px-3">HSN</th>
                            <th className="text-right py-2 px-3">Qty</th>
                            <th className="text-right py-2 px-3">Rate</th>
                            <th className="text-right py-2 px-3">Disc %</th>
                            <th className="text-right py-2 px-3">Tax %</th>
                            <th className="text-right py-2 px-3">Net Amount</th>
                            <th className="text-center py-2 px-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {billItems.map((item, index) => (
                            <tr key={index} className="border-b">
                                <td className="py-2 px-3">{index + 1}</td>
                                <td className="py-2 px-3">{item.desc}</td>
                                <td className="py-2 px-3">{item.HSN}</td>
                                <td className="py-2 px-3 text-right">{item.qty}</td>
                                <td className="py-2 px-3 text-right">{item.rate.toFixed(2)}</td>
                                <td className="py-2 px-3 text-right">{item.discPercent.toFixed(2)}</td>
                                <td className="py-2 px-3 text-right">{item.taxPercent}</td>
                                <td className="py-2 px-3 text-right font-semibold">{item.netAmount.toFixed(2)}</td>
                                <td className="text-center py-2 px-3">
                                    <button onClick={() => handleEditItem(item, index)} className="text-indigo-600 hover:text-indigo-800 mr-2">Edit</button>
                                    <button onClick={() => handleRemoveBillItem(index)} className="text-red-500 hover:text-red-700">Remove</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="font-bold bg-gray-100">
                            <td colSpan="7" className="text-right py-2 px-3">Net Total:</td>
                            <td className="py-2 px-3 text-right">{netTotal.toFixed(2)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div className="flex justify-between pt-4 border-t mt-6">
            <button onClick={() => setPage(2)} className="px-6 py-2 bg-gray-600 text-white rounded">Back</button>
            <button onClick={() => setPage(4)} disabled={isPage3NextDisabled} className="px-6 py-2 bg-indigo-600 text-white rounded disabled:bg-gray-400">Next</button>
        </div>
    </>
  );
};

export default Page3;
